import LightGallery from 'lightgallery/react';
import './Gal.css';


// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';


// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgShare from 'lightgallery/plugins/share';
import lgRotate from 'lightgallery/plugins/rotate';

const images = [
    { src: "images/Ba03/BA 03 (13).jpg", alt: "1" },
    { src: "images/Ba03/BA 03 (12).jpg", alt: "2" },
    { src: "images/Ba03/BA 03 (11).jpg", alt: "3" },
    { src: "images/Ba03/BA 03 (1).jpg", alt: "4" },
    { src: "images/Ba03/BA 03 (2).jpg", alt: "5" },
    { src: "images/Ba03/BA 03 (3).jpg", alt: "6" },
    { src: "images/Ba03/BA 03 (4).jpg", alt: "7" },
    { src: "images/Ba03/BA 03 (5).jpg", alt: "8" },
    { src: "images/Ba03/BA 03 (6).jpg", alt: "9" },
    { src: "images/Ba03/BA 03 (7).jpg", alt: "10" },
    { src: "images/Ba03/BA 03 (8).jpg", alt: "11" },
    { src: "images/Ba03/BA 03 (9).jpg", alt: "12" },
    { src: "images/Ba03/BA 03 (10).jpg", alt: "13" },
    { src: "images/Ba03/BA 03 (14).jpg", alt: "14" },
    { src: "images/Ba03/BA 03 (15).jpg", alt: "15" },
   
]

function Galc3() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="gallery-container">
             <h1>Slab</h1>
            <p className='about'> We specialize in the construction and installation of concrete slabs for various applications. Our expertise ensures strong, level, and durable slabs that provide a solid foundation for any building project
            </p>    <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom, lgAutoplay, lgFullscreen, lgRotate, lgShare]}
            >

                {images.map((image, index) => {
                    return (
                        <a href={image.src} key={index}>
                            <img alt={image.alt} src={image.src} />
                        </a>
                    )
                })}


            </LightGallery>
        </div>
    );
}
export default Galc3;
